import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);
class BorderDrawer {
    constructor(divElement, startPercent, hideBottomLine) {
        this.div = divElement;
        this.startPercent = startPercent;
        this.hideBottomLine = hideBottomLine;
        this.isFirst = this.div.classList.contains('gl-border-first');

        this.svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        this.path1 = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        this.path2 = document.createElementNS('http://www.w3.org/2000/svg', 'path');

        this.path1.setAttribute('fill', 'none');
        this.path1.setAttribute('stroke', '#a0a3a9');
        this.path1.setAttribute('stroke-width', '1');

        this.path2.setAttribute('fill', 'none');
        this.path2.setAttribute('stroke', '#a0a3a9');
        this.path2.setAttribute('stroke-width', '1');

        this.svg.appendChild(this.path1);
        this.svg.appendChild(this.path2);
        this.div.appendChild(this.svg);

        // Observe size changes
        const resizeObserver = new ResizeObserver(() => {
            const resizeEvent = new CustomEvent('resizeDivDraw', {
                detail: { div: this.div }
            });
            window.dispatchEvent(resizeEvent);
        });

        resizeObserver.observe(this.div);

        window.addEventListener('resizeDivDraw', (e) => {
            if(this.timelines && this.timelines.length > 0) {
                console.log('resizeDivDraw');
                if(e.detail.div === this.div) {
                    this.update();
                }
                setTimeout(() => {
                    this.timelines.forEach(t => {
                        if(t.scrollTrigger) {
                            t.scrollTrigger.refresh();
                        }
                    })
                }, 10)
            }
        })

        this.update();
    }

    update() {
        if (this.timelines && this.timelines.length > 0) {
            this.timelines.forEach(t => {
                if (t.scrollTrigger) {
                    t.scrollTrigger.kill();
                    t.scrollTrigger = null;
                }
                t.kill();
            })
        }

        const {width, height} = this.div.getBoundingClientRect();
        const strokeWidth = parseInt(this.path1.getAttribute('stroke-width'));
        this.height = height;
        this.width = width;

        this.svg.style.position = 'absolute';
        this.svg.style.left = `${-strokeWidth}px`;
        this.svg.style.top = `${-strokeWidth}px`;
        this.svg.style.width = `${width + strokeWidth}px`;
        this.svg.style.height = this.hideBottomLine ? `${height + strokeWidth}px` : `${height + 2 * strokeWidth}px`;

        const startWidth = (width + strokeWidth) * (this.startPercent / 100);
        const bottomLine = height + strokeWidth;

        let pathData1, pathData2;

        if (this.hideBottomLine) {
            pathData1 = `M${startWidth} ${strokeWidth/2} H${width} V${bottomLine}`;
            pathData2 = `M${startWidth} ${strokeWidth/2} H${strokeWidth/2} V${bottomLine}`;
        } else {
            pathData1 = `M${startWidth} ${strokeWidth/2} H${width} V${bottomLine} H${width/2}`;
            pathData2 = `M${startWidth} ${strokeWidth/2} H${strokeWidth/2} V${bottomLine} H${width/2}`;
        }

        this.path1.setAttribute('d', pathData1);
        this.path2.setAttribute('d', pathData2);
        this.path1.setAttribute('stroke-width', '0.9');
        this.path2.setAttribute('stroke-width', '0.9');

        const longestInitialLineLength = Math.max(Math.abs(width + strokeWidth - startWidth), Math.abs(strokeWidth/2 - startWidth));
        const totalWidth = width + strokeWidth;
        this.timelines = [];
        this.animate(this.path1, Math.abs(width + strokeWidth - startWidth), totalWidth, height, longestInitialLineLength);
        this.animate(this.path2, Math.abs(strokeWidth/2 - startWidth), totalWidth, height, longestInitialLineLength);
    }

    calculateSpeedMultiplier() {
        const windowHeight = window.innerHeight;
        const x1 = 800, y1 = 49;
        const x2 = 1030, y2 = 62;

        // Calculate the slope
        const m = (y2 - y1) / (x2 - x1);

        // Calculate the y-intercept
        const b = y1 - m * x1;

        // Calculate and return the speed multiplier
        return m * windowHeight + b;
    }

    animate(path, initialLineLength) {
        const totalPathLength = path.getTotalLength();
        let initialDuration = this.calculateSpeedMultiplier() * Math.pow(this.div.getBoundingClientRect().height, -0.806900); // 49.770845 x 800
        if(initialDuration < 0.01) initialDuration = 0.01;
        const remainingDuration = 1 - initialDuration;

        path.style.strokeDasharray = totalPathLength;
        path.style.strokeDashoffset = totalPathLength;

        const st = {
            trigger: this.div,
            start: () => {
                return this.isFirst ? 'top 66%' : 'top 90%'
            },
            end: 'bottom 60%',
            scrub: 1,
            invalidateOnRefresh: true,
        };

        const timeline = gsap.timeline({ scrollTrigger: st });

        timeline.to(path, {
            strokeDashoffset: totalPathLength - initialLineLength,
            duration: initialDuration,
            ease: 'none',
        }, 0);

        if (this.hideBottomLine) {
            timeline.to(path, {
                strokeDashoffset: 0,
                duration: remainingDuration,
                ease: 'none',
            }, initialDuration);
        } else {
            const partDuration = remainingDuration - initialDuration / 2

            timeline.to(path, {
                strokeDashoffset: this.width / 2,
                duration: partDuration,
                ease: 'none',
            }, initialDuration);

            timeline.to(path, {
                strokeDashoffset: 0,
                duration: initialDuration / 2,
                ease: 'none',
            }, initialDuration + partDuration);
        }

        this.timelines.push(timeline);
    }
}

export default BorderDrawer;
